var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivityCustomers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3327 16.5V14.8333C18.3327 13.2801 17.2704 11.9751 15.8327 11.605M12.916 1.7423C14.1376 2.23679 14.9993 3.43443 14.9993 4.83333C14.9993 6.23224 14.1376 7.42988 12.916 7.92437M14.166 16.5C14.166 14.9469 14.166 14.1703 13.9123 13.5577C13.574 12.741 12.9251 12.092 12.1083 11.7537C11.4957 11.5 10.7192 11.5 9.16602 11.5H6.66602C5.11288 11.5 4.33631 11.5 3.72374 11.7537C2.90698 12.092 2.25806 12.741 1.91975 13.5577C1.66602 14.1703 1.66602 14.9469 1.66602 16.5M11.2493 4.83333C11.2493 6.67428 9.75697 8.16667 7.91602 8.16667C6.07507 8.16667 4.58268 6.67428 4.58268 4.83333C4.58268 2.99238 6.07507 1.5 7.91602 1.5C9.75697 1.5 11.2493 2.99238 11.2493 4.83333Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityCustomers);
export default __webpack_public_path__ + "static/media/activity-customers.effff8146c5521533fff9507a1645e76.svg";
export { ForwardRef as ReactComponent };